import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ✅ Import translation namespaces

// ✅ Import namespaces
import authEn from './locales/en/auth.json';
import headerEn from './locales/en/header.json';
import topbarEn from './locales/en/topbar.json';
import footerEn from './locales/en/footer.json';
import userEn from './locales/en/user.json';


import authZh from './locales/zh/auth.json';
import headerZh from './locales/zh/header.json';
import topbarZh from './locales/zh/topbar.json';
import footerZh from './locales/zh/footer.json';
import userZh from './locales/zh/user.json';


import authEl from './locales/el/auth.json';
import headerEl from './locales/el/header.json';
import topbarEl from './locales/el/topbar.json';
import footerEl from './locales/el/footer.json';
import userEl from './locales/el/user.json';

// ✅ Initialize i18n


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { auth: authEn, header: headerEn, topbar: topbarEn, footer: footerEn, user: userEn },
            el: { auth: authEl, header: headerEl, topbar: topbarEl, footer: footerEl, user: userEl },
            zh: { auth: authZh, header: headerZh, topbar: topbarZh, footer: footerZh, user: userZh }
        },
        fallbackLng: 'en',
        ns: ['auth', 'header', 'topbar', 'footer', 'user'],
        defaultNS: 'auth',
        interpolation: { escapeValue: false }
    });


export default i18n;
